import React from 'react';
import { gql } from '@apollo/client';

import { Query } from '@apollo/client/react/components';

import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import NextRankingPublishDate from 'buyside/components/presentation/RankingsIndexPage/NextRankingPublishDate';

const NextRankingPublishDateQuery = gql`
  query {
    nextRankingPublishDate
  }
`;

export const NextRankingPublishDateQueryContainer = ({ children }) => {
  return (
    <Query query={NextRankingPublishDateQuery}>
      {({ loading, data }) => {
        if (loading || !data) {
          return children({ loading: true, data });
        }
        const { nextRankingPublishDate } = data;
        return children({ loading: false, data: { nextRankingPublishDate } });
      }}
    </Query>
  );
};

const NextRankingPublishDateContainer = () => {
  return (
    <NextRankingPublishDateQueryContainer>
      {({ loading, data }) => {
        if (loading) {
          return <LoadingSpinner size="tiniest" />;
        }
        const { nextRankingPublishDate } = data;
        return <NextRankingPublishDate date={nextRankingPublishDate} />;
      }}
    </NextRankingPublishDateQueryContainer>
  );
};

export default NextRankingPublishDateContainer;
